import {useEffect, useState} from "react";
import {getPreviouslyOrderedProducts} from "../api/product-ordered-previously";

export default function usePreviouslyOrderedProducts(productIds, isAvailable) {
    const [products, setProducts] = useState({})
    const [loading, setLoading] = useState(false);

    const loadProducts = async () => {
        if (!isAvailable) {
            return;
        }
        setLoading(true);
        const previouslyOrderedProducts = productIds.length > 0 ? await getPreviouslyOrderedProducts(productIds) : {};
        setLoading(false);
        setProducts(previouslyOrderedProducts);
    };

    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            loadProducts();
        }

        return () => {
            ignore = true;
        }
    }, [productIds]);

    return {
        products,
        loading,
    };
}